import Navbar from "../../components/navbar/Navbar";
// import Leftlayout from "../../components/leftlayout/Leftlayout";
// import Sidebar from "../../components/sidebar/Sidebar";
import LoginPopup from "../login/Login";
import NoticePopup from "../../components/popupfiles/noticepopup/noticePopup";
import ChatPopup from "../../components/popupfiles/chatpopup/chatPopup";
import MainUserTable from "../../components/mainlayout/mainusertable";

const UserTable = () => {
  return (
    <div className="UserTable">
      <Navbar />
      {/* <Leftlayout /> */}
      <LoginPopup />
      <NoticePopup />
      <ChatPopup />
      <MainUserTable />
    </div>
  );
};

export default UserTable;
